import dates from "tools/dates";

import Modelsaleline from "./ModelSaleLine";
import { checkRequiredForm } from "tools/form";
import TableDisplay from "apps/RestOrder/components/TableDisplay";
// import Transfer from "./Transfer";
import MenuRest from "apps/RestOrder/components/MenuRest";

const searchParty = (value) => {
  if (!value) return [];
  const dom = [
    "OR",
    ["name", "ilike", `%${value}%`],
    ["id_number", "ilike", `${value}%`],
  ];
  return dom;
};

function formatTime(seconds) {
  const hours = Math.floor(seconds / 1000 / 60 / 60);
  const remainingMinutes = Math.floor(seconds / 1000 / 60) % 60;
  const remainingSeconds = Math.floor((seconds / 1000) % 60);

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = remainingMinutes.toString().padStart(2, "0");
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function getTime(rec) {
  const today = new Date();

  const created_ =
    rec["order_status_time."]?.created ?? rec["create_date"].split(".", 1)[0];
  const created = dates.getTrytonDateTime2Js(created_, true) ?? today;
  const commanded =
    dates.getTrytonDateTime2Js(rec["order_status_time."]?.commanded, true) ??
    today;

  const time = formatTime(commanded.getTime() - created.getTime());
  return time;
}

function getTimeCreated(record) {
  const created =
    record["order_status_time."]?.created ??
    record["create_date"].split(".", 1)[0];
  return created;
}

const getTotalAmount = (record) => {
  const { delivery_amount, lines, total_amount } = record;
  console.log("record", record);
  let totalAmount = total_amount;
  if (lines && !Array.isArray(lines)) {
    const delivery =
      delivery_amount && typeof delivery_amount === "string"
        ? Number(delivery_amount.replaceAll(",", ""))
        : 0;
    totalAmount = delivery;
    lines?.forEach((item) => {
      totalAmount = totalAmount + parseFloat(item.amount_w_tax);
    });
  }
  return totalAmount;
};

function isVisibleSend(name, store) {
  let res = false;
  console.log(store, ".... send");

  if (store.lines && store.id > 0) {
    for (const line of store.lines.values()) {
      if (line.id <= 0 || line.status_order === "draft") {
        res = true;
      }
    }
  }

  return res;
}
const validateConfirm = (field, toActive) => {
  const storeRequired = ["lines", "shop", "source", "kind", "consumer"];

  if (toActive.id > 0) return false;
  const res = checkRequiredForm(toActive, storeRequired);
  return res;
};

const requiredTable = (record) => record?.kind?.id === "to_table";

const requiredConsumer = (record) => record?.kind?.id !== "to_table";

function visibleTable(name, record) {
  return record?.kind?.id === "to_table" && !record?.transfer_to;
}

function visibleMenu(name, record) {
  return record?.state === "draft" && record?.shop?.id > 0;
}

function visibleDelivery(name, record) {
  return record?.kind?.id === "delivery";
}

const visibleTransfer = (name, record) =>
  record?.kind?.id === "to_table" && !record?.table_assigned;

const getTableScreen = ({ attrs, field, record }) => {
  return TableDisplay({ attrs, field, record });
};

const readOnlyParty = (record) => record.state !== "draft";

const getTransfer = (record) => {
  return record?.transfer_to?.rec_name ?? "";
};

const searchConsumer = (value) => {
  if (!value) return [];
  const dom = [
    "OR",
    ["name", "ilike", `%${value}%`],
    ["id_number", "ilike", `${value}%`],
    ["phone", "ilike", `${value}%`],
  ];
  return dom;
};

const paymentMethod = [
  { id: "terminal", name: "terminal" },
  { id: "cash", name: "cash" },
  { id: "partial_paid", name: "partial_paid" },
  { id: "all_paid", name: "all_paid" },
];

const kind = [
  { id: "take_away", name: "take_away" },
  { id: "to_table", name: "to_table" },
  { id: "delivery", name: "delivery" },
];

const stateColors = {
  draft: "rose",
  requested: "slate",
  commanded: "lime",
  dispatched: "sky",
  delivered: "amber",
};

const getView = (config) => {
  let DictCtxView = {
    row_selectable: false,
    activeSearch: true,
    model: "sale.sale",
    form_action: ["add"],
    table_action: ["edit"],
    tags: {
      order_status: stateColors,
    },
    webfields: {
      total_amount: {
        type: "numeric",
        readOnly: true,
        depends: ["lines", "delivery_amount"],
        function: getTotalAmount,
        search: true,
      },
      number: {
        type: "char",
        depends: ["create_date"],
        readOnly: true,
        visible: (_, record) => record.number !== undefined,
        searchable: true,
      },
      party: {
        type: "many2one",
        model: "party.party",
        recSearch: searchParty,
        readOnly: readOnlyParty,
      },
      source: {
        type: "many2one",
        model: "sale.source",
        readOnly: true,
        required: true,
      },
      table_assigned: {
        type: "many2one",
        recName: "name",
        model: "sale.shop.table",
        required: requiredTable,
        visible: visibleTable,
        component: getTableScreen,
      },
      persons: {
        type: "integer",
        default: 2,
        // readOnly: true,
      },
      // transfer_to: {
      //   type: "button_custom_modal",
      //   Component: Transfer,
      //   visible: visibleTransfer,
      //   button_ok: false,
      //   function: getTransfer,
      //   search: true,
      //   attrs: ["rec_name"],
      //   size: "rounded-full w-full",
      // },
      consumer: {
        type: "many2one",
        model: "party.consumer",
        recSearch: searchConsumer,
        required: requiredConsumer,
        searchable: true,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        readOnly: true,
        searchable: true,
      },
      sale_date: {
        type: "date",
        readOnly: { state: ["quotation"] },
        searchable: true,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
      },
      order_status: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
        tags: stateColors,
      },
      shop: {
        type: "many2one",
        model: "sale.shop",
        attrs: ["product_categories.childs"],
        readOnly: true,
        required: true,
        searchable: true,
      },
      position: {
        type: "char",
      },
      see_menu: {
        type: "button_custom_modal",
        Component: MenuRest,
        visible: visibleMenu,
        color: "amber",
      },
      lines: {
        type: "one2many",
        model: "sale.line",
        ctxView: Modelsaleline.ctxView(config),
      },
      delivery_amount: {
        type: "numeric",
        withChange: getTotalAmount,
        visible: visibleDelivery,
      },
      description: { type: "char", readOnly: { state: ["quotation"] } },
      kind: {
        type: "selection",
        options: kind,
        readOnly: true,
        translate: true,
        required: true,
      },
      comment: { type: "text", readOnly: { state: ["quotation"] } },
      "order_status_time.created": {
        type: "datetime",
        search: true,
        function: getTimeCreated,
      },
      "order_status_time.commanded": {
        type: "datetime",
        // search: true,
        // function: get_time_commanded,
      },
      elapsed_time: {
        type: "char",
        function: getTime,
      },
      payment_method: {
        type: "selection",
        options: paymentMethod,
        required: true,
        default: { id: "cash", name: "cash" },
        translate: true,
      },
      confirm: {
        type: "button",
        method: "dash_create_order_call",
        resetForm: true,
        visible: validateConfirm,
      },
      send_order: {
        type: "button",
        method: "send_order",
        color: "green",
        visible: isVisibleSend,
      },
    },
    webtree: [
      { name: "number", width: "20%" },
      { name: "sale_date", width: "25%" },
      { name: "shop", width: "25%" },
      { name: "party", width: "25%" },
      { name: "consumer", width: "25%" },
      { name: "agent", width: "25%" },
      { name: "order_status", width: "30%", widget: "badge" },
      { name: "total_amount", width: "25%" },
      { name: "delivery_amount", width: "25%" },
      {
        name: "order_status_time.created",
        width: "15",
        formatString: "HH:mm:ss",
      },
      {
        name: "order_status_time.commanded",
        width: "15",
        formatString: "HH:mm:ss",
      },
      { name: "elapsed_time", width: "15" },
    ],
    webform: [
      {
        id: "infoSale",
        grid: [{ name: "source" }, { name: "shop" }, { name: "kind" }],
        cols: "grid-cols-1 lg:grid-cols-3",
        colSpan: "col-span-1",
      },
      {
        id: "wizardSale",
        grid: [
          { name: "table_assigned", widget: "custom" },
          // { name: "transfer_to" },
          { name: "number" },
        ],
        cols: "grid-cols-2",
        colSpan: "col-span-1",
      },
      { name: "consumer" },
      { name: "party" },
      {
        id: "infoSale2",
        grid: [
          { name: "position" },
          { name: "payment_method" },
          { name: "persons" },
          { name: "delivery_amount" },
          { name: "see_menu" },
        ],
        cols: "grid-cols-4",
        colSpan: "col-span-2",
      },
      { name: "lines" },
      { name: "comment" },
      { name: "total_amount" },
      { name: "state" },
      { name: "confirm" },
      { name: "send_order" },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
